import React from 'react'
import { Modal } from '@zambezi/sdk/modal'
import { closeModal$ } from '@apiEnabler/api-enabler-common/lib/intents'
import { followStoreLink$ } from '../../navigation'

import style from './MobileNavigationModal.module.css'
import modalStyle from '@apiEnabler/ob-common/lib/view/modal.module.css'

const NavigationLink = ({ path, label }) => (
  <div className={style.navLinkContainer}>
    <a
      onClick={() => {
        followStoreLink$.next(path)
        closeModal$.next()
      }}
    >
      {label}
    </a>
  </div>
)

const MobileNavigationModal = ({ open, onClose, onConfirm, brand }) => (
  <Modal
    className={`${modalStyle.modal} js-modal`}
    title="Access Store"
    withBackdrop={true}
    withPadding={false}
    open={open}
    onCancel={onClose}
    onConfirm={onConfirm}
    renderFooter={onConfirm => {
      return (
        <div className={style.footer}>
          <a
            href={brand.getIn(['links', 'reportFraud'])}
            target="_blank"
            rel="noopener noreferrer"
          >
            Report a fraud
          </a>
          <a className={style.logout} onClick={onConfirm}>
            Logout
          </a>
        </div>
      )
    }}
  >
    <div className={style.container}>
      <div>
        <NavigationLink path="/payments" label="Payments and transfers" />
        <NavigationLink path="/recurring-payments" label="Recurring payments" />
        <NavigationLink path="/funds-checks/tpps" label="Funds checks" />
        <NavigationLink path="/access-agreements/tpps" label="Access" />
      </div>
    </div>
  </Modal>
)

export default MobileNavigationModal
